import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDeleteData } from "../Hooks/useDeleteData";
import Email from "../Icons/Email";
import ViewIcon from "../Icons/ViewIcon";
import { FaCheckCircle, FaClipboardCheck, FaEye, FaHourglassHalf, FaRegFileAlt, FaRegThumbsUp, FaTimesCircle } from "react-icons/fa";
import { GetAccess, GetRole } from "./roles";
import EditIcon from "../Icons/Edit";
import DeleteIcon from "../Icons/Delete";
import Chat from "../Icons/Chat";
import ModalContainer from "../Others/ModalContainer";
import { Modal, Tooltip } from "antd";
import EditEmailSent from "../../Views/Web/E-Mail/EmailSent/EditEmailSent";
import ViewEmailSent from "../../Views/Web/E-Mail/EmailSent/ViewEmailSent";
import EditEquipments from "../../Views/Web/Settings/Equipments/EditEquipments";
import ViewEquipments from "../../Views/Web/Settings/Equipments/ViewEquipments";



const MoreOptions = ({
    data,
    fetcher,
    id,
    removevalue,
    url,
    moduleName,
    from,
    viewLink,
    editLink,
    EmailRequired,
    emailEnable,
    isEmailSent,
    EditAccess = "",
    DeteleAccess = "",
    emailType,
    adminPermmision,
    curentPage,
    searchQuery
  }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
  
    const { handle } = useDeleteData(fetcher);
    const handleDelete = async () => handle(url + `${id}`, setIsModalOpen);
    let Edit = editLink ? true : null;
    let Comment = editLink ? false : null;
  
    let EditCondition = editLink?.includes("{id}") ? true : false;
    let editableLink = EditCondition ? editLink.replace("{id}", `${id}`) : "";
  
    let Delete = true;
    
  
    const getStatusIcon = () => {
      const status = data?.approvalStatus?.toLowerCase();
    
      switch (status) {
        case "approved":
          return (
            <Tooltip title={<p className="text-[11px]">Approved</p>} color="#22c55e">
              <FaCheckCircle className="text-green-500" />
            </Tooltip>
          );
        case "pending":
          return (
            <Tooltip title={<p className="text-[11px]">Pending</p>} color="#eab308">
              <FaHourglassHalf className="text-yellow-500" />
            </Tooltip>
          );
        case "rejected":
        case "declined":
          return (
            <Tooltip title={<p className="text-[11px]">{status.charAt(0).toUpperCase() + status.slice(1)}</p>} color="#ef4444">
              <FaTimesCircle className="text-red-500" />
            </Tooltip>
          );
        case "verified":
          return (
            <Tooltip title={<p className="text-[11px]">Verified</p>} color="#a855f7">
              <FaClipboardCheck className="text-purple-500" />
            </Tooltip>
          );
        case "reviewed":
          return (
            <Tooltip title={<p className="text-[11px]">Reviewed</p>} color="#6366f1">
              <FaRegFileAlt className="text-indigo-500" />
            </Tooltip>
          );
        default:
          return null;
      }
    };
  
    console.log("EDIT ",Edit,moduleName);
    console.log("EDIT ACCESS",GetAccess(EditAccess));
    console.log("DELETE ACCESS",GetAccess(DeteleAccess));
    

    const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
  
    const openEditModal = () => {
      setIsEditModalOpen(true);
     
    };
  
    const openViewModal = () => {
      setIsViewModalOpen(true);
     
    };

    const [isViewModalOpenEmail, setIsViewModalOpenEmail] = useState(false); // View modal state
    const [isEditModalOpenEmail, setIsEditModalOpenEmail] = useState(false); // Edit modal state
  
    const openEditModalEmail = () => {
      setIsEditModalOpenEmail(true);
     
    };
  
    const openViewModalEmail = () => {
      setIsViewModalOpenEmail(true);
     
    };
  
    return (
      <>
        <div className=" w-full flex  justify-center items-center">
          <div className=" w-full flex justify-center ">
            
          {moduleName !== "Sales-Orders" && (
    <div className="w-[20%] overflow-hidden flex justify-center items-center">
      {getStatusIcon()}
    </div>
  )}
  
            {EmailRequired && !isEmailSent && !data?.purchaser && emailEnable && (
              <div
                className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                <Email height={"3"} width={"3"} color="#BF2EF0" />
              </div>
            )}
            {moduleName === "Equipments" && (
          <>
            {/* View Icon */}
            <div
              className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
              onClick={openViewModal}
            >
              <ViewIcon  color="#048178" />
            </div>

           
              <div
                className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
                onClick={openEditModal}
              >

                <EditIcon color="skyblue" width={"12"} height={"12"} />
              </div>
            
          </>
        )}   
          {moduleName === "Email" && (
          <>
            {/* View Icon */}
            <div
              className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
              onClick={openViewModalEmail}
            >
              <ViewIcon  color="#048178" />
            </div>

           
              {/* <div
                className="w-[25%] overflow-hidden flex justify-center items-center cursor-pointer"
                onClick={openEditModalEmail}
              >

                <EditIcon color="skyblue" width={"12"} height={"12"} />
              </div> */}
            
          </>
        )}   
         {(moduleName !== "Equipments" && moduleName !== 'Email' )&& (
           <> <div className=" w-[25%] overflow-hidden flex justify-center items-center">
              <Link
                className=" text-black hover:text-black border-none"
                to={viewLink + `${id}`}
                state={{ 
                  data: data,
                  pageIndex:curentPage,
                  searchQuery: searchQuery!==""?searchQuery:searchQuery
                 }}
              >
                <ViewIcon color="#048178" />
              </Link>
            </div>
            {Edit && (
              <>
              
                  
                   {moduleName === "Client Ticket" &&
                    (
                      <>
                      {GetAccess(EditAccess) && (
                      <div className=" w-[25%] overflow-hidden flex justify-center items-center ">
                        <Link
                          className=" text-black hover:text-black border-none"
                          to={EditCondition ? editableLink : editLink + `${id}`}
                          state={{ data: data, from: from }}
                        >
                          <EditIcon color="skyblue" width={"12"} height={"12"} />
                        </Link>
                      </div>
                    )}
                      </>
                    )}
                    </>)}
                     
                 
            {/* {Delete && ( */}
              {/* <> */}
                {/* {data?.approvalStatus?.toLowerCase() == "verified" ||
                data?.approvalStatus?.toLowerCase() == "approved" ? (
                  <>
                    {GetRole() && (
                      <div
                        className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <DeleteIcon height={"13"} width={"13"} color="lightcoral" />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {GetAccess(DeteleAccess) && (
                      <div
                        className=" w-[25%] overflow-hidden flex justify-center items-center cursor-pointer "
                        onClick={() => {
                          setIsModalOpen(true);
                        }}
                      >
                        <DeleteIcon height={"13"} width={"13"} color="lightcoral" />
                      </div>
                    )} 
                  </>
                )} */}
              </>
            )}
  
            {Comment && (
              <div className=" w-[25%] overflow-hidden flex justify-center items-center  cursor-pointer ">
                <Chat width={"11"} height={"11"} />
              </div>
            )}
          </div>
        </div>
        <ModalContainer
          visiable={isModalOpen}
          title="Warning"
          content={`Are you sure, ${removevalue} will removed from ${moduleName}!`}
          handleClick={() => handleDelete()}
          closeModal={() => setIsModalOpen(false)}
        />

{isEditModalOpen&&(
       <EditEquipments
        open={isEditModalOpen}
        data={data}
        onCancel={() => setIsEditModalOpen(false)}
        getData={fetcher}
        firstProject={id}       
      />
    )}

          {isViewModalOpen && (       
        <Modal
        open={isViewModalOpen}
        onCancel={()=>setIsViewModalOpen(false)}
        title={"View Equipment"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        {/* <ViewActivity/> */}
        <ViewEquipments data={data} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
      </Modal>
      )}
      {isEditModalOpenEmail&&(
       <EditEmailSent
        open={isEditModalOpenEmail}
        data={data}
        onCancel={() => setIsEditModalOpenEmail(false)}
        getData={fetcher}
        firstProject={id}       
      />
    )}

          {isViewModalOpenEmail && (       
        <Modal
        open={isViewModalOpenEmail}
        onCancel={()=>setIsViewModalOpenEmail(false)}
        title={"View"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        {/* <ViewActivity/> */}
        <ViewEmailSent data={data} open={isViewModalOpenEmail} onCancel={() => setIsViewModalOpen(false)} />
      </Modal>
      )}

        {/* <ModalEmail
          visiable={modalOpen}
          title=""
          hasContent={true}
          content={
            <>
              <EmailModal
                fetcher={fetcher}
                vendorId={data?.vendor || data?.vendorId}
                id={data?.id}
                url={url}
                idd={id}
                onClose={() => setModalOpen(false)}
                emailType={emailType}
              />
            </>
          }
          // handleClick={() => {}}
          hasButton={false}
          // outSideClick={false}
          closeModal={() => setModalOpen(false)}
        /> */}
      </>
    );
  };
  export default MoreOptions;
